export default {
  tips: {
    google: 'google authenticator is not connect, please connect first',
    tip: 'can not settlement'
  },
  label: {
    withdrawalAmountTotal: 'Total withdrawal amount',
    handlingFeeTotal: 'fee',
    agentNo: 'AgentNo',
    account: 'account holder',
    actualTransferAmount: 'Actual amount received',
    bankName: 'bank Name',
    bankNo: 'Bank account',
    bankCode: "Bank code",
    createAcct: 'Creator',
    createTime: 'Create Time',
    operatorName:'xuất khoản tự động',
    handlingFee: 'Fee',
    bankLoginAccount: 'Sign in account',
    bankLoginPwd: 'Sign in password',
    merchatName: 'merchant name',
    asyncStatus: {
      label: "Notify status",
      status: {
        "0": "No yet",
        "1": "Success",
        "-1": "Fail"
      }
    },
    payoutFeeCount: "Fee count",
    payoutAmountCount: "Amount count",
    receiver: "Receiver",
    paymentBank: "Payment bank",
    paymentName: "Payer",
    paymentAccount: "Payment account",
    applyTime: "Apply time",
    notifyTime: "Notify time",
    agentFee: "Agent fee",
    id: 'Primary key id',
    merchatNo: 'merchatNo',
    remark: 'note',
    reviewer: 'approved by',
    type: 'type',
    updateAcct: 'updater',
    updateTime: 'update time',
    withdrawalAmount: 'withdraw amount',
    withdrawalNo: 'transaction code',
    withdrawalStatus: 'status',
    action: 'operation',
    totalBalance: 'Total balance available for payment',
    payoutSumAmount: 'Total payout',
    systemOrderNo: "System order number",
    amount: "Amount to be paid",
    accountBankCode: "Payment bank code",
    accountNumber: "Withdrawal account number",
    accountName: "Payer Name",
    description: "content",
    beneficiaryName: "Payee Name",
    payTime: "payment time",
    payAmount: "Success amount",
    cashType: {
      label: "Fund Type",
      status: [
        { label: "Transfer", value: "+" },
        { label: "Transfer out", value: "-" },
      ]
    },
    orderNo: "Merchant order number",
    merchantNo: "merchant number",
    merchantName: "Merchant name",
    payoutType1:"Automatic payment",
    payoutType2:"Manual payment",
    paymentType:"Payment Type",
    paymentFixedFeeTatal:'Total fixed handling fee paid',
    autoSuccessAmount:'Automatic success amount',
    manualSuccessAmount:'Successful order amount',
  },
  rules: {
    bankNo: {
      required: 'Bank Acount cannot be empty',
      type: 'Bank account must be a number',
      min: 'Bank account must be greater than or equal to 9'
    },
    bankName: {
      required: 'Bank name cannot be empty',
    },
    depositor: {
      required: 'The bank account holder cannot be empty',
    },
    cardNumber: {
      required: 'Bank card number cannot be empty',
    },
    bankCode: {
      required: 'Bank code cannot be empty',
    },
    loginName: {
      required: 'Bank login user name cannot be empty',
    },
    otp: {
      required: 'Please enter a transaction code of 6 to 8 digits',
    },
  },
  orderDescription: 'Order description',
  withdrawalInterval: 'Withdrawal interval',
  bankInfo_label1: 'Daily limit on payout count',
  bankInfo_label2: 'Minimum payout amount',
  bankInfo_label3: 'Maximum payout amount',
  bankInfo_label4: 'Daily cumulative count',
  batchSettings: 'Batch settings'
};



// WEBPACK FOOTER //
// ./src/i18n/lang/en/withdraw.js